import { isPlainObject, isArray } from 'lodash'
import { decode } from './mix'
const convertCore = async data => {
  const { fieldtype, fieldvalue } = data
  // TODO: number不确定是否需要加解密
  if (
    fieldtype === 'text' ||
    fieldtype === 'editor' ||
    fieldtype === 'area.address'
  ) {
    data.fieldvalue = await decode(fieldvalue)
  } else if (fieldtype === 'area') {
    if (isPlainObject(fieldvalue)) {
      if (fieldvalue.address) {
        fieldvalue.address = await decode(fieldvalue.address)
      }
    }
  } else if (fieldtype === 'select_tree') {
    if (isPlainObject(fieldvalue)) {
      if (fieldvalue.input) {
        fieldvalue.input = await decode(fieldvalue.input)
      }
    }
  } else if (
    fieldtype === 'tag' ||
    fieldtype === 'email' ||
    fieldtype === 'phone'
  ) {
    if (isArray(fieldvalue)) {
      const arr = []
      for (let value of fieldvalue) {
        arr.push(await decode(value))
      }
      data.fieldvalue = arr
    }
  }
  return data.fieldvalue
}

const convert = async data => {
  if (isPlainObject(data)) {
    if (data.fieldtype && data.fieldvalue) {
      data.fieldvalue = await convertCore(data)
    } else {
      const children = Object.keys(data)
      for (let key of children) {
        const child = data[key]
        data[key] = await convert(child)
      }
    }
  }
  return data
}

// 询盘列表页面列表接口数据解密
export const decodeInqueryList = async payload => {
  const { list = [] } = payload && payload.data
  const arr = []
  for (let item of list) {
    const newItem = await convert(item)
    arr.push(newItem)
  }
  payload.data.list = arr
  return payload
}

// 询盘列表页面列表接口数据解密
export const decodeQuitList = async payload => {
  const { list = [] } = payload.data
  const arr = []
  for (let item of list) {
    const newItem = await convert(item)
    arr.push(newItem)
  }
  payload.data.list = arr
  return payload
}

// 询盘详情页面接口数据解密
export const decodeInqueryDetail = async payload => {
  const arr1 = payload && Object.keys(payload)
  const newObject = {}
  const convert1 = async child => {
    const arr = []
    for (let item of child) {
      const { child: child2 } = item
      if (child2 && isArray(child2)) {
        item.child = await convert1(child2)
      }
      if (item.fieldtype && item.fieldvalue) {
        item.fieldvalue = await convertCore(item)
        if (item.fieldtype === 'editor' && item.fieldvalue) {
          item.fieldvalue = item.fieldvalue
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
        }
      }
      arr.push(item)
    }
    return arr
  }
  for (let key of arr1) {
    const item = payload[key]
    if (isPlainObject(item)) {
      // 判断是否有fieldtype字段和child字段
      if (item.child && isArray(item.child)) {
        item.child = await convert1(item.child)
      }
    }
    newObject[key] = item
  }
  return newObject
}

// 询盘详情页面变更历史详情接口数据解密
export const decodeInqueryHistoryDetail = async payload => {
  const newObject = {}
  for (let k in payload) {
    const data = payload[k] || {} // befor, after
    if (isPlainObject(data)) {
      newObject[k] = data
      for (let fieldkey in data) {
        let { fieldvalue } = data[fieldkey]
        switch (data[fieldkey].newfieldtype) {
          case 'text':
          case 'phone':
          case 'email':
          case 'editor':
          case 'select_tree':
          case 'tag':
            fieldvalue = await decode(fieldvalue)
            break
        }
        newObject[k][fieldkey].fieldvalue = fieldvalue || '- -'
      }
    }
  }
  return newObject
}
